/* eslint-disable @typescript-eslint/naming-convention */
import { environment } from './environments/environment';
import { Auth } from '@aws-amplify/auth';

Auth.configure({
  region: environment.region,
  userPoolId: environment.userPoolId,
  userPoolWebClientId: environment.userPoolClientId,
  mandatorySignIn: true,
  oauth: {
    domain:
      environment.cognitoDomain +
      '.auth.' +
      environment.region +
      '.amazoncognito.com',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: environment.redirectSignIn,
    redirectSignOut: environment.redirectSignOut,
    responseType: 'code',
  },
});
